var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156 156"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 78,
    r: 78,
    fill: "#a71680"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f9af05",
    d: "M59 53h13v49H59zM86 53h13v49H86z"
  })));
}
export default SvgPause;